import styled from "styled-components";

import { Button } from "./Button";
import { black200 } from "styles/colors";
import { convertHexToRGB } from "styles/colors";

interface Styles {
  background?: string;
}

export const PrimaryButton = styled(Button)<Styles>`
  box-shadow: ${({ background }) =>
    `0 0.5rem 1rem ${convertHexToRGB(background || '', 0.24)}`};
  font-weight: 700;

  &:hover:enabled {
    box-shadow: none;
  }
  &:active:enabled {
    box-shadow: none;
    filter: brightness(90%);
  }
  &:disabled {
    background-color: ${black200};
    box-shadow: none;
  }
`;
